import { queryClient } from "@/lib/queryClient";
import {
  spySerpService,
  type SpyserpDateRangeParams,
} from "@/services/SpySerpService";

export const getSpyserpDateRangeQueryKey = ({
  dateRange,
  customFrom,
  customTo,
}: SpyserpDateRangeParams) =>
  [
    "spyserp",
    "dateRange",
    dateRange,
    customFrom ?? null,
    customTo ?? null,
  ] as const;

export const ensureSpyserpDateRange = (params: SpyserpDateRangeParams) =>
  queryClient.ensureQueryData({
    queryKey: getSpyserpDateRangeQueryKey(params),
    queryFn: () => spySerpService.resolveDateRange(params),
    staleTime: 1000 * 60 * 5,
  });
